module.exports = __webpack_public_path__ + "img/carousel.f28aaa7f.svg";